// Generated by CoffeeScript 1.9.3
(function() {
  var InvalidFilterError;

  InvalidFilterError = require('error-types');

  rjm.model.RestrictionSet = Backbone.RelationalModel.extend({
    initialize: function(options) {
      if (!options.hasOwnProperty("restrictions") || !options.hasOwnProperty("sequence")) {
        throw "InvalidConstructorArgs - Restriction Set";
      }
      _.bindAll(this, "addRestriction", "validateIndicies", "getRestrictionBySid", "removeRestrictionBySid", "getNextLetterInSequence", "getRestrictionByIndex", "removeRestrictionByIndex", "clone", "equal");
      return this.get("sequence").bind("syntaxTreeUpdated", this.validateIndicies);
    },
    addRestriction: function(restriction, operator) {
      var nextLetter;
      if (operator.toLowerCase() !== "and" && operator.toLowerCase() !== "or") {
        throw "Invalid restriction set operator: " + operator;
      }
      nextLetter = this.getNextLetterInSequence();
      this.get("restrictions").add(restriction, {
        silent: true
      });
      if (this.get("sequence").isEmpty()) {
        this.get("sequence").set({
          string: nextLetter
        });
      } else {
        this.get("sequence").set({
          string: this.get("sequence").get("string") + " " + operator + " " + nextLetter
        });
      }
      this.get("restrictions").trigger("add");
      return this.trigger("change", this);
    },
    validateIndicies: function() {
      _(this.get("sequence").getIndiciesUsedInTree()).each((function(_this) {
        return function(index) {
          if (!_this.getRestrictionByIndex(index)) {
            throw new InvalidFilterError("Filter string references non-existant filter");
          }
        };
      })(this));
      if (this.get("restrictions").length !== _.uniq(this.get("sequence").getIndiciesUsedInTree()).length) {
        throw new InvalidFilterError("Filter string has to reference all filters");
      }
      return true;
    },
    getRestrictionBySid: function(sid) {
      return this.get("restrictions").filter((function(_this) {
        return function(rest) {
          return rest.get("left").get("sid") === sid;
        };
      })(this));
    },
    removeRestrictionBySid: function(sid) {
      this.get("restrictions").each((function(_this) {
        return function(rest, index) {
          if (rest.get("left").get("sid") === sid) {
            return _this.removeRestrictionByIndex(index);
          }
        };
      })(this));
      return this.trigger("change", this);
    },
    getNextLetterInSequence: function() {
      return encodedLetterString.indexToAlpha(this.get("restrictions").length);
    },
    getRestrictionByIndex: function(index) {
      return this.get("restrictions").at(index);
    },
    removeRestrictionByIndex: function(index) {
      var restriction;
      restriction = this.getRestrictionByIndex(index);
      this.get("restrictions").remove(restriction, {
        silent: true
      });
      this.get("sequence").cleanseReferenceToRestrictionByIndex(index);
      if (this.get("sequence").isEmpty() && this.get("restrictions").length > 0) {
        this.get("sequence").set({
          string: "[A]"
        });
      }
      this.get("restrictions").trigger("remove", restriction);
      return this.trigger("change", this);
    },
    clone: function() {
      return new rjm.model.RestrictionSet(this.toJSON());
    },
    equal: function(restrictionSet) {
      var allEqual;
      if (restrictionSet == null) {
        return false;
      }
      if (restrictionSet.get("restrictions").size() !== this.get("restrictions").size()) {
        return false;
      }
      if (!this.get("sequence").equal(restrictionSet.get("sequence"))) {
        return false;
      }
      allEqual = true;
      this.get("restrictions").each(function(restriction, index) {
        if (!restriction.equal(restrictionSet.get("restrictions").at(index))) {
          return allEqual = false;
        }
      });
      return allEqual;
    },
    relations: [
      {
        type: Backbone.HasMany,
        key: "restrictions",
        relatedModel: "rjm.model.Restriction",
        includeInJSON: true
      }, {
        type: Backbone.HasOne,
        key: "sequence",
        relatedModel: "rjm.model.RestrictionSequence",
        includeInJSON: true
      }
    ]
  });

}).call(this);
